import scaldWolfGarden from "../assests/images/branches/scald_wolf_garden.jpeg";
import scaldAkcakoca from "../assests/images/branches/scald_akcakoca.jpeg";
import scalYeldegirmeni from "../assests/images/branches/scald_yeldegirmeni.jpeg";

export const branches = [
    {
        id: 1,
        name: "Scald Akçakoca",
        address: "Osmaniye, Atatürk Cd., 81650 Akçakoca/Düzce",
        phone: "+90 545 956 31 45",
        lat: 41.0896633,
        lng: 31.1302742,
        image: scaldAkcakoca,
        mapsUrl:
            "https://www.google.com/maps/place/Scald/@41.0894396,31.1325063,1395m/data=!3m1!1e3!4m6!3m5!1s0x409db30068cb7c33:0x578ccff5cad35a3!8m2!3d41.0896633!4d31.1302742!16s%2Fg%2F11wbm6tvjq",
    },
    {
        id: 2,
        name: "Scald Kadıköy Yeldeğirmeni",
        address: "Rasimpaşa, Karakolhane Cd. No:30, 34716 Kadıköy/İstanbul",
        phone: "+90 545 956 31 45",
        lat: 40.9945132,
        lng: 29.0298494,
        image: scalYeldegirmeni,
        mapsUrl:
            "https://www.google.com/maps/place/Scald+Coffee+%26+Patisserie/@40.9945132,29.0298494,820m/data=!3m2!1e3!4b1!4m6!3m5!1s0x14cab9001b6f606b:0xcf3b274b6e86e1e6!8m2!3d40.9945132!4d29.0298494!16s%2Fg%2F11z0yk0c1b?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D",
    },
    {
        id: 2,
        name: "Scald Wolf Garden",
        address: "Değirmen ağzı mevki, Hacı Yusuflar, Susam Sk. No: 5, 81650 Akçakoca/Düzce",
        phone: "+90 545 956 31 45",
        lat: 41.0820551,
        lng: 31.1009379,
        image: scaldWolfGarden,
        mapsUrl:
            "https://www.google.com/maps/place/Scald+Garden/@41.0820551,31.1009379,625m/data=!3m2!1e3!4b1!4m6!3m5!1s0x409db3bf2025a84b:0x47fa85e049ca8249!8m2!3d41.0820551!4d31.1009379!16s%2Fg%2F11kqyr17_k?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D",
    },
];
